﻿function debounce(func, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout((...args) => { timer = 0; func(...args); }, timeout, ...args);
	};
}

function debounce_leading(func, timeout = 300) {
	let timer;
	return (...args) => {
		if (!timer) {
			func(...args);
		}
		clearTimeout(timer);
		timer = setTimeout(() => {
			timer = undefined;
		}, timeout);
	};
}

export { debounce, debounce_leading };